export enum TimerEnum {
  XXS = 15,
  XS = 20,
  CH = 30,
  MD = 40,
  GD = 60,
  XL = 90,
  XXL= 180,
  XXXL = 300,
  INITIAL = 20000
}
